<template>
  <div>
    <b-row class="mb-3">
      <b-col lg="4" md="6" xs="12">
        <b-form-datepicker @input="inputChanged" v-model="initialDate" class="mb-2"></b-form-datepicker>
      </b-col>
      <b-col lg="4" md="6" xs="12">
        <b-form-datepicker @input="inputChanged" v-model="lastDate" :min="minLastDate" class="mb-2"></b-form-datepicker>
      </b-col>
      <b-col lg="4" md="6" xs="12">
        <b-button class="mb-2" variant="default" v-b-modal.modal-sucursals block>Sucursales: {{ sucursals.length }} Seleccionadas</b-button>
      </b-col>
      <b-col lg="12" md="6" xs="12">
        <b-button variant="success" @click="changeDate" block>Buscar</b-button>
      </b-col>
    </b-row>
    <b-modal ok-only id="modal-sucursals" @ok="inputChanged" title="sucursals">
      <b-row>
        <b-col>
          <b-button-group>
            <b-button variant="success" @click="selectAllsucursals()">Seleccionar todo</b-button>
            <b-button variant="danger" @click="sucursals = []">Quitar seleccion</b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <b-form-checkbox-group stacked v-model="sucursals" :options="sucOptions">
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';


export default {
  name: "ReportSearchBar",
  watch: {
    initialDate(i) {
      this.minLastDate=moment(i).format()
      // this.minLastDate = moment(i).add(1, 'days').format()
      if (moment(this.initialDate).isAfter(moment(this.lastDate))) {
        this.lastDate = null
      }
    },
    init(e){
      this.init=e
      this.initialDate = moment(this.init).format()
    },
    end(e){
      this.end=e
      this.lastDate = moment(this.end).format()
    },
    sucursales(e){
      this.sucursales=e
      this.sucursals=e.split(",")
    }
  },
  props: {
    emitOnStart: {
      type:Boolean,
      default: true
    },
    emitOnChange: {
      type:Boolean,
      default: true
    },
    //props
    init: {
      type:[String,Date],
      default: null,
      Required:false
    },
    end:{
      type:[String,Date],
      default: null,
      Required:false
    },
    sucursales:{
      type:[String,Int32Array],
      default: null,
      Required:false
    },
  },
  data() {
    return {
      allSucsArray: [],
      initialDate: null,
      lastDate: null,
      minLastDate: null,
      sucOptions: [],
      sucursals: []
    };
  },
  mounted() {
    console.log("reportDatesMounted")
    moment().locale("es-mx")
    if(typeof(this.sucursales)=="string"){
      this.sucursals=this.sucursales.split(",")
    }
    if(this.init!=null && this.end!=null){
      console.log("dates found")
      console.log(this.init)
      console.log(this.end)
      this.initialDate = moment(this.init).format()
      this.lastDate = moment(this.end).format()
    }else{
      this.initialDate = moment().subtract(7, "days").format()
      this.lastDate = moment().add(1, "days").format()
    }
    this.minLastDate = moment(this.initialDate).add(1, 'days').format()
    this.getSucursals()
  },
  methods: {
    selectAllsucursals() {
      let that = this
      this.sucursals = []
      this.sucOptions.forEach((element) => {
        that.sucursals.push(element.value)
      })
    },
    getSucursals() {
      let that = this;
      axios
        .get("/sucursals")
        .then(function (response) {
          let l=response.data.sort((a, b) => { return a.nombre.localeCompare(b.nombre) })
          let fill=false
          if(that.sucursals.length==0){
            fill=true
          }
          l.forEach((element) => {
            that.sucOptions.push({ text: element.nombre, value: element.id });
            if(fill){
              that.sucursals.push(element.id)
            }
          });
          if(that.emitOnStart){
            that.changeDate()
          }
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    changeDate() {
      console.log("changeDate")
      this.$emit("search",{sucursales: this.sucursals,initDate: this.initialDate,endDate:this.lastDate})
    },
    inputChanged(){
      if(this.emitOnChange){
        this.changeDate()
      }
      this.$emit("changed",{sucursales: this.sucursals,init: this.initialDate,end:this.lastDate})
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  }
}
</script>